

export const calcSize = (byteSize: number) : string => {
    const sizes = ["bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    const sizeIdx = Math.floor(Math.log(byteSize) / Math.log(1024));
    return Math.round(byteSize / Math.pow(1024.0, sizeIdx)) + sizes[sizeIdx];
}